var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDocPng(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "52px",
    viewBox: "0 0 40 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-Documents-uploadFile",
    transform: "translate(-613.000000, -460.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-png",
    transform: "translate(613.000000, 460.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F7F7F7",
    fillRule: "nonzero",
    points: "0 0 31.6574187 0 40 8.45064822 40 52 0 52"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6E7CCE",
    fillRule: "nonzero",
    points: "-1.29674049e-13 -2.66897615e-13 31.5172581 -2.66897615e-13 39.8229032 8.30564516 39.8229032 12.3017742 -1.29674049e-13 12.3017742"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EBECEC",
    fillRule: "nonzero",
    points: "31.5172581 -4.08562073e-14 31.5172581 8.30564516 39.8229032 8.30564516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.85532258,9.8366129 L2.85532258,2.6216129 L5.19032258,2.6216129 C6.07709677,2.6216129 6.65048387,2.65709677 6.91951613,2.73096774 C7.3333871,2.84032258 7.67919355,3.07387097 7.95693548,3.43741935 C8.23774194,3.80096774 8.3766129,4.26806452 8.3766129,4.84145161 C8.3766129,5.28483871 8.29677419,5.65725806 8.13725806,5.95870968 C7.97467742,6.26322581 7.77080645,6.49967742 7.52548387,6.67096774 C7.27725806,6.84241935 7.02596774,6.95774194 6.77177419,7.01387097 C6.42306452,7.08177419 5.92048387,7.11725806 5.26145161,7.11725806 L4.31564516,7.11725806 L4.31564516,9.8366129 L2.85532258,9.8366129 Z M4.31548387,3.84241935 L4.31548387,5.8966129 L5.11064516,5.8966129 C5.68403226,5.8966129 6.06241935,5.85822581 6.25741935,5.78435484 C6.44951613,5.70758065 6.60032258,5.58935484 6.70967742,5.42677419 C6.81903226,5.26709677 6.87516129,5.08096774 6.87516129,4.86516129 C6.87516129,4.60209677 6.7983871,4.3833871 6.64467742,4.21193548 C6.49096774,4.04048387 6.29596774,3.93403226 6.05951613,3.88983871 C5.88806452,3.86032258 5.53935484,3.84258065 5.01612903,3.84258065 L4.31548387,3.84258065 L4.31548387,3.84241935 Z M9.5766129,9.8366129 L9.5766129,2.6216129 L10.9895161,2.6216129 L13.96,7.45725806 L13.96,2.6216129 L15.3077419,2.6216129 L15.3077419,9.8366129 L13.8504839,9.8366129 L10.9243548,5.09564516 L10.9243548,9.8366129 L9.5766129,9.8366129 Z M20.2085484,7.1883871 L20.2085484,5.96774194 L23.3416129,5.96774194 L23.3416129,8.8466129 C23.0370968,9.14225806 22.5967742,9.40532258 22.0174194,9.62983871 C21.4380645,9.85435484 20.8529032,9.96967742 20.2587097,9.96967742 C19.505,9.96967742 18.848871,9.81 18.2872581,9.49387097 C17.7285484,9.17467742 17.3059677,8.71951613 17.0222581,8.13129032 C16.7414516,7.54016129 16.5995161,6.89870968 16.5995161,6.20419355 C16.5995161,5.4533871 16.7591935,4.78548387 17.0724194,4.19725806 C17.3887097,3.61209677 17.8467742,3.16274194 18.4556452,2.85241935 C18.9167742,2.61 19.4930645,2.49177419 20.1817742,2.49177419 C21.0743548,2.49177419 21.775,2.68096774 22.2803226,3.05629032 C22.7827419,3.43467742 23.105,3.95193548 23.2498387,4.61693548 L21.7985484,4.88887097 C21.6980645,4.53709677 21.508871,4.25629032 21.2280645,4.04951613 C20.9472581,3.84258065 20.5985484,3.74209677 20.1787097,3.74209677 C19.5432258,3.74209677 19.0377419,3.94306452 18.6653226,4.34806452 C18.29,4.75306452 18.1008065,5.35306452 18.1008065,6.14516129 C18.1008065,7.00532258 18.29,7.6466129 18.6712903,8.07532258 C19.0525806,8.50387097 19.5491935,8.71967742 20.1669355,8.71967742 C20.4683871,8.71967742 20.7758065,8.65758065 21.0803226,8.53935484 C21.3877419,8.42112903 21.6508065,8.2733871 21.8695161,8.10193548 L21.8695161,7.18854839 L20.2085484,7.18854839 L20.2085484,7.1883871 Z",
    id: "Shape",
    fill: "#F8F8F8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#6E7CCE",
    fillRule: "nonzero",
    points: "7.70564516 18.9877419 32.1172581 18.9877419 32.1172581 43.4020968 7.70564516 43.4020968"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#BACFFF",
    fillRule: "nonzero",
    points: "9.60032258 21.3404839 30.2225806 21.3404839 30.2225806 37.1093548 9.60032258 37.1093548"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F8F8F8",
    fillRule: "nonzero",
    points: "9.60032258 21.3404839 13.7235484 21.3404839 13.7235484 25.2833871 9.60032258 25.2833871"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#58515E",
    fillRule: "nonzero",
    points: "17.8498387 21.3404839 13.7235484 21.3404839 13.7235484 25.2833871 17.8498387 25.2833871"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F8F8F8",
    fillRule: "nonzero",
    points: "17.8498387 21.3404839 21.9730645 21.3404839 21.9730645 25.2833871 17.8498387 25.2833871"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#58515E",
    fillRule: "nonzero",
    points: "26.0962903 21.3404839 21.9730645 21.3404839 21.9730645 25.2833871 26.0962903 25.2833871"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F8F8F8",
    fillRule: "nonzero",
    points: "26.0962903 21.3404839 30.2225806 21.3404839 30.2225806 25.2833871 26.0962903 25.2833871"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#58515E",
    fillRule: "nonzero",
    points: "9.60032258 29.2233871 13.7235484 29.2233871 13.7235484 25.2804839 9.60032258 25.2804839"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F8F8F8",
    fillRule: "nonzero",
    points: "17.8498387 29.2233871 13.7235484 29.2233871 13.7235484 25.2804839 17.8498387 25.2804839"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#58515E",
    fillRule: "nonzero",
    points: "17.8498387 29.2233871 21.9730645 29.2233871 21.9730645 25.2804839 17.8498387 25.2804839"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F8F8F8",
    fillRule: "nonzero",
    points: "26.0962903 29.2233871 21.9730645 29.2233871 21.9730645 25.2804839 26.0962903 25.2804839"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#58515E",
    fillRule: "nonzero",
    points: "26.0962903 29.2233871 30.2225806 29.2233871 30.2225806 25.2804839 26.0962903 25.2804839"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F8F8F8",
    fillRule: "nonzero",
    points: "9.60032258 29.2233871 13.7235484 29.2233871 13.7235484 33.1664516 9.60032258 33.1664516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#58515E",
    fillRule: "nonzero",
    points: "17.8498387 29.2233871 13.7235484 29.2233871 13.7235484 33.1664516 17.8498387 33.1664516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F8F8F8",
    fillRule: "nonzero",
    points: "17.8498387 29.2233871 21.9730645 29.2233871 21.9730645 33.1664516 17.8498387 33.1664516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#58515E",
    fillRule: "nonzero",
    points: "26.0962903 29.2233871 21.9730645 29.2233871 21.9730645 33.1664516 26.0962903 33.1664516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F8F8F8",
    fillRule: "nonzero",
    points: "26.0962903 29.2233871 30.2225806 29.2233871 30.2225806 33.1664516 26.0962903 33.1664516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#58515E",
    fillRule: "nonzero",
    points: "9.60032258 37.1093548 13.7235484 37.1093548 13.7235484 33.1664516 9.60032258 33.1664516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "17.8498387 37.1093548 13.7235484 37.1093548 13.7235484 33.1664516 17.8498387 33.1664516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#666666",
    fillRule: "nonzero",
    points: "17.8498387 37.1093548 21.9730645 37.1093548 21.9730645 33.1664516 17.8498387 33.1664516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "26.0962903 37.1093548 21.9730645 37.1093548 21.9730645 33.1664516 26.0962903 33.1664516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#58515E",
    fillRule: "nonzero",
    points: "26.0962903 37.1093548 30.2225806 37.1093548 30.2225806 33.1664516 26.0962903 33.1664516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#5ED1B3",
    fillRule: "nonzero",
    points: "30.2225806 37.1093548 22.983871 27.4293548 18.3375806 33.66 14.8053226 31.0677419 9.60032258 37.1093548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2014516,23.1819355 C16.4575806,23.1819355 17.4743548,24.2016129 17.4743548,25.4579032 C17.4743548,26.7141935 16.4575806,27.7308065 15.2014516,27.7308065 C13.9453226,27.7308065 12.9254839,26.7140323 12.9254839,25.4579032 C12.9254839,24.2017742 13.9453226,23.1819355 15.2014516,23.1819355 Z",
    id: "Path",
    fill: "#FFD630",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocPng);
export default __webpack_public_path__ + "static/media/icDocPNG.090009b1b7a6ebb80a965dae1a497b96.svg";
export { ForwardRef as ReactComponent };